import http from "V2.0/services/httpService";

const ENDPOINTS = {
  REGISTER_INSTAGRAM: "/instagram/manage/whitelabelRegister",
  INSTAGRAM_CONFIG: "/instagram/manage/whitelabelConfig",
  DELETE_INSTAGRAM_CONFIG: "/instagram/manage/whitelabelConfig",
};

function registerInstagram({ workspaceId, payload }) {
  return http.post(`${ENDPOINTS.REGISTER_INSTAGRAM}/${workspaceId}`, payload);
}

function getInstagramConfig({ workspaceId }) {
  return http.get(`${ENDPOINTS.INSTAGRAM_CONFIG}/${workspaceId}`);
}

function deleteInstagramConfig({ workspaceId }) {
  return http.delete(`${ENDPOINTS.DELETE_INSTAGRAM_CONFIG}/${workspaceId}`);
}

export { getInstagramConfig, registerInstagram, deleteInstagramConfig };
